import route from '@/router/index'
// import {authLogout} from '../security/index'
import Stomp from 'webstomp-client'
import {ACCESS_TOKEN_EXPIRED, ACCESS_TOKEN_NAME} from '../constant'

const socket = (function () {
  let isConnected
  let connection
  let stompClient

  let connect = function (successCallback, errorCallback) {
    let accessToken = localStorage.getItem(ACCESS_TOKEN_NAME);
    let expTime = localStorage.getItem(ACCESS_TOKEN_EXPIRED);
    var dateExpTime = new Date(expTime * 1);
    var currentTime = new Date();
    if (accessToken && currentTime <= dateExpTime && !isConnected) {
      connection = new WebSocket(process.env.DOMAIN_API_ADDRESS + '/radio_central_cms')
      stompClient = Stomp.over(connection)

      stompClient.heartbeat.outgoing = 0;
      stompClient.heartbeat.incoming = 0;

      /* Disable console */
      stompClient.debug = function () {
        return '';
      }
      const headers = {
        'Authorization': 'Bearer ' + accessToken
      };
      stompClient.connect(
        headers,
        () => {
          isConnected = true
          stompClient.subscribe('/errors', function () {
            isConnected = false
          })
          successCallback(stompClient);
        },
        error => {
          isConnected = false
          errorCallback(error)
        }
      )
    }
    if (connection) {
      connection.onclose = function (e) {
        isConnected = false;
        setTimeout(function () {
          connect(successCallback, errorCallback);
        }, 1000);
      };

      connection.onerror = function (err) {
        isConnected = false;
        connection.close();
      };
    }
  }

  let sendMessage = function (path, data) {
    if (stompClient && stompClient.connected && connection.readyState === WebSocket.OPEN) {
      stompClient.send(path, data, {})
    }
  }

  let disconnect = function () {
    if (stompClient && stompClient.connected && connection.readyState === WebSocket.OPEN) {
      stompClient.disconnect()
      isConnected = false;
    }
  }

  let hasConnected = function () {
    return isConnected
  }

  let init = function () {
  }

  init()

  return {
    isConnected: hasConnected,
    disconnect: disconnect,
    sendMessage: sendMessage,
    connect: connect,
  }
})(route)

export function checkConnect() {
  return socket.isConnected()
}

export function connect(successCallback, errorCallback) {
  return socket.connect(successCallback, errorCallback)
}

export function disConnectSocket() {
  return socket.disconnect()
}

export function sendMessageSocket(path, data) {
  return socket.sendMessage(path, data)
}

